// variables for production environment
const prod = {
    basename: '',
    api_url: 'https://lepetittrainpaimpolais.com/wp-json/wp/v2/',
    contact_url: 'https://lepetittrainpaimpolais.com/wp-json/contact/v1/send'
};

// variables for development environment
const dev = {
    basename: '/lepetittrainpaimpolais',
    api_url: 'http://localhost/lepetittrainpaimpolais/index.php/wp-json/wp/v2/',
    contact_url: 'http://localhost/lepetittrainpaimpolais/wp-json/contact/v1/send'
};

export const dataApi = {
    apiKey: 'AIzaSyDM9oCumOpyRDeAdYyL7ebcRc_lqsWwpc4',
    accessToken: 'ya29.a0AWY7Ckm2aopepVWAfpXgM73vOaTPXSS55atpw82Zi9eyqON_Hs0InUGMPGVWVWUeWcu9ktYZnwGdwdNA6hoGWVJm6wMZjOuIvLQkExPLskN_Bwk_B9s_qMdytsm0b8CBxmY7O7-5Bq31eE-itSh_PzP_rZeAaCgYKAdwSARESFQG1tDrp9NJwGPJZDfqNkjvMVHWh_Q0163',
    calendarId: 'fredleput@gmail.com'
}

export const urls = process.env.NODE_ENV === 'development' ? dev : prod;